/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_TimeInputs */

const bn_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সময়`)
};

const de_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit`)
};

const el_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φορά`)
};

const en_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const es_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo`)
};

const fr_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps`)
};

const hi_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const hu_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idő`)
};

const id_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu`)
};

const it_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

const ja_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const ko_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간`)
};

const nl_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd`)
};

const pl_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas`)
};

const pt_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

const ru_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время`)
};

const sv_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid`)
};

const tr_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaman`)
};

const uk_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`час`)
};

const vi_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian`)
};

const zh_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间`)
};

const zh_hant_game_stat_time = /** @type {(inputs: Game_Stat_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Game_Stat_TimeInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_time = /** @type {((inputs?: Game_Stat_TimeInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_TimeInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_time(inputs)
	if (locale === "de") return de_game_stat_time(inputs)
	if (locale === "el") return el_game_stat_time(inputs)
	if (locale === "en") return en_game_stat_time(inputs)
	if (locale === "es") return es_game_stat_time(inputs)
	if (locale === "fr") return fr_game_stat_time(inputs)
	if (locale === "hi") return hi_game_stat_time(inputs)
	if (locale === "hu") return hu_game_stat_time(inputs)
	if (locale === "id") return id_game_stat_time(inputs)
	if (locale === "it") return it_game_stat_time(inputs)
	if (locale === "ja") return ja_game_stat_time(inputs)
	if (locale === "ko") return ko_game_stat_time(inputs)
	if (locale === "nl") return nl_game_stat_time(inputs)
	if (locale === "pl") return pl_game_stat_time(inputs)
	if (locale === "pt") return pt_game_stat_time(inputs)
	if (locale === "ru") return ru_game_stat_time(inputs)
	if (locale === "sv") return sv_game_stat_time(inputs)
	if (locale === "tr") return tr_game_stat_time(inputs)
	if (locale === "uk") return uk_game_stat_time(inputs)
	if (locale === "vi") return vi_game_stat_time(inputs)
	if (locale === "zh") return zh_game_stat_time(inputs)
	return zh_hant_game_stat_time(inputs)
});